import React, { useState, useEffect, useMemo } from 'react'
import i18n from 'i18n/index.js'
import { fetchWithLocale } from "components/utils/Api.jsx";
import { buildLocalePath } from "components/utils/Locale";
import HomeImage from "components/home/HomeImage";
import OiCarousel from "components/shared/OiCarousel";

const REGION_CAROUSEL_BREAKPOINTS = [
  { minWidth: 375, slidesPerView: 1.2 },
  { minWidth: 425, slidesPerView: 1.2 },
  { minWidth: 768, slidesPerView: 3.2 },
  { minWidth: 1024, slidesPerView: 4 },
  { minWidth: 1280, slidesPerView: 5 },
  { minWidth: 1440, slidesPerView: 6 },
];

function CarouselRegion(props) {
  const [regions, setRegions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [slidesSkeletons, setSlidesSkeletons] = useState(1);

  let skeleton_height = 330;

  useEffect(() => {
    const updateSkeletonCount = () => {
      const width = window.innerWidth;
      if (width >= 1440) setSlidesSkeletons(6);
      else if (width >= 1280) setSlidesSkeletons(5);
      else if (width >= 1024) setSlidesSkeletons(4);
      else if (width >= 768) setSlidesSkeletons(3);
      else if (width >= 425) setSlidesSkeletons(1);
      else setSlidesSkeletons(1);
    };
    updateSkeletonCount();
    window.addEventListener("resize", updateSkeletonCount);
    return () => window.removeEventListener("resize", updateSkeletonCount);
  }, []);

  useEffect(() => {
    get_regions();
  }, []);

  function get_regions() {
    setLoading(true);
    return fetchWithLocale(`/get_regions.json`)
      .then(response => response.json())
      .then(json => {
        setRegions(json.regions);
        setLoading(false);
      })
      .catch(error => console.log(error));
  }

  const regionsWithExcursions = useMemo(
    () => (regions || []).filter((r) => r.excursions_numbers > 0),
    [regions]
  );

  return (
    <section className="caroussel">
      <section className="products-section">
        {loading ? (
          <section className="carousel-skeletons-loader carousel-home__skeleton-row">
            {Array.from({ length: slidesSkeletons }).map((_, idx) => (
              <div
                key={`region-skeleton-${idx}`}
                className="carousel-home__skeleton-cell--region region-loader oi-skeleton oi-skeleton--wave oi-skeleton--rounded oi-w-full"
                style={{ height: skeleton_height }}
                aria-hidden
              />
            ))}
          </section>
        ) : (
          <OiCarousel
            className="carouselregion"
            items={regionsWithExcursions}
            gap={24}
            breakpoints={REGION_CAROUSEL_BREAKPOINTS}
            ariaLabel="Regiones"
            getItemKey={(region) => `regions-label-${region.id}`}
            renderItem={(region) => (
              <a
                href={buildLocalePath(`products?region=${region.id}`)}
                className="product-region-image oi-stack-center"
                target="_blank"
                rel="noopener noreferrer"
                title="View Details"
              >
                <HomeImage
                  image_url={region.large}
                  alt={region.description}
                  height={skeleton_height}
                  home_class={"region-figure"}
                />
                <div className="oi-cover-center">
                  <h3 className="product-white-label">{region.name}</h3>
                  <h4 className="product-region-numbers">
                    {region.excursions_numbers} + {i18n.t('home.excursions')}
                  </h4>
                </div>
              </a>
            )}
          />
        )}
      </section>
    </section>
  );
}

export default CarouselRegion;
